import { useQuery } from "@tanstack/react-query";

import { getErrorMessage, transformInspectionType } from "../utils/utilities";
import { SelectOption } from "../utils/models";

import * as service from '../services/projectService';

export interface ProgressTrail {
	_id: string;
	createdAt: string;
	projectId: string;
	updatedAt: string;
	userDesignation: string;
	userId: string;
	userName: string;
	description: string;
}

const fetchInspectionTypes = async () => {
    const result = await service.getInspectionTypes();
    const types = result.data.map(transformInspectionType);

    return types;
};

const useInspectionTypes = () => {
    const { data, dataUpdatedAt, error, isFetching, refetch } = useQuery<SelectOption[]>({
        queryKey: ['inspection-types'],
        queryFn: () => fetchInspectionTypes(),
        initialData: [],
    });

    return {
        data,
        loading: isFetching,
        error: error ? getErrorMessage(error) : '',
        lastUpdated: dataUpdatedAt,
        refetch,
    };
};
 
export default useInspectionTypes;